import { $ } from 'utils/dom';

const $carousel = $('.info-screen-wrapper__carousel');

if ($carousel) {
  Promise.all([import('flickity'), import('flickity-fade')]).then(
    ([_, { default: Flickity }]) => {
      const flickity = new Flickity($carousel, {
        draggable: false,
        wrapAround: true,
        fade: true,
        autoPlay: 8 * 1000,
        pageDots: false,
        prevNextButtons: false,
        pauseAutoPlayOnHover: false,
      });

      // Disable clicks
      flickity.element.style.pointerEvents = 'none';
    }
  );
}
